import { createContext } from "react";

export const AppTheme = {
  light: {
    foreground: "#000",
    background: "#f5f5f5",
    border: "#dbdbdb",
  },
  dark: {
    foreground: "#fff",
    background: "#1D1D25",
    border: "#4e4e4e",
  },
};

const ThemeContext = createContext(["light", () => {}]);

export default ThemeContext;
